import Ajax from "src/ajax";
import get from "lodash/get";
import { push } from "src/features/Notification/notificationSlice";

const path = "package-bundle";

/**
 * Actions
 */
const FETCH_REQUEST = `${path}/fetch-request`;
const FETCH_REQUEST_SUCCESS = `${path}/fetch-success`;
const FETCH_REQUEST_FAIL = `${path}/fetch-fail`;

const DELETE_REQUEST = `${path}/delete-request`;
const DELETE_REQUEST_SUCCESS = `${path}/delete-success`;
// eslint-disable-next-line
const DELETE_REQUEST_FAIL = `${path}/delete-fail`;

/**
 * Side Effects
 */
export const fetchList = (queries) => async (dispatch) => {
  dispatch({ type: FETCH_REQUEST });
  try {
    const options = {
      method: "GET",
      url: path,
      params: queries,
    };
    const response = await Ajax(options);
    const list = response.data.package_bundle;
    const total = response.data.total;
    const page = response.data.page;
    dispatch({ type: FETCH_REQUEST_SUCCESS, payload: { list, total, page } });
  } catch (error) {
    const error_text = get(error, "response.data.error");
    // set fetching = false + error text
    dispatch({ type: FETCH_REQUEST_FAIL, payload: error_text });
  }
};

export const removeById = (id) => async (dispatch) => {
  dispatch({ type: DELETE_REQUEST, payload: id });
  try {
    const options = {
      method: "PUT",
      url: `${path}/${id}/inactive`,
    };
    // eslint-disable-next-line
    const response = await Ajax(options);
    dispatch({ type: DELETE_REQUEST_SUCCESS, payload: id });
    dispatch(
      push({
        title: "Success",
        description: "Successful, Products were listed",
        severity: "success",
      })
    );
  } catch (error) {
    // eslint-disable-next-line
    const error_text = get(error, "response.data.error");
    // set fetching = false + error text
    // dispatch({ type: FETCH_REQUEST_FAIL, payload: error_text });
    dispatch(
      push({
        title: "Error",
        description: `An error occurred please try again later.`,
        severity: "error",
      })
    );
  }
};

/**
 * Initial State
 */
const initialState = {
  fetching: false,
  list: [],
  total: 0,
  page: 1,
  // loading for create & edit
  processing: false,
  error: null,
  delete_req: [],
};

/**
 * Reducer
 */
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_REQUEST:
      return { ...state, fetching: true, error: null };
    case FETCH_REQUEST_SUCCESS:
      return {
        ...state,
        fetching: false,
        list: action.payload.list,
        total: action.payload.total,
        page: action.payload.page,
      };
    case FETCH_REQUEST_FAIL:
      return { ...state, fetching: false, error: action.payload };
    case DELETE_REQUEST:
      return {
        ...state,
        delete_req: [...state.delete_req, action.payload],
      };
    case DELETE_REQUEST_SUCCESS:
      return {
        ...state,
        delete_req: state.delete_req.filter((id) => id !== action.payload),
      };
    default:
      return state;
  }
}
